export const initAdvantages = () => {
	const advantages = document.querySelector( 'section.advantages ul' );

	if ( !advantages )
	{
		return;
	}

	const updateHeights = () => {
		let maxHeight = 0;
		
		if ( window.innerWidth < 1100 )
		{
			Array.from( advantages.children ).forEach( ( it : HTMLElement ) => {
				const paragraph = it.querySelector( 'p' );
				const title = it.querySelector( 'h3' );

				if ( !paragraph || !title )
				{
					return;
				}

				const height = 66 + paragraph.offsetHeight + title.offsetHeight;
				
				if ( height > maxHeight )
				{
					maxHeight = height;
				}
			} );

			Array.from( advantages.children ).forEach( ( it : HTMLElement ) => {
				it.style.height = maxHeight + 'px';
			} );
		}
		else
		{
			Array.from( advantages.children ).forEach( ( it : HTMLElement ) => {
				it.removeAttribute( 'style' );
			} );
		}
	};

	setTimeout( updateHeights, 1000 );
	window.addEventListener( 'resize', updateHeights );
};


// WEBPACK FOOTER //
// ./app/Routes/Index/Advantages/index.ts